/* Workspace */
export const CHANGE_WORKSPACE_EVENT = "CHANGE_WORKSPACE_EVENT";
export const CHANGE_WORKSPACE_ACTION = "CHANGE_WORKSPACE_ACTION";

